// components/InterstitialAd.tsx
import { useEffect, useRef, useContext } from 'react'
import { SessionDataContext } from 'providers/Session';
import { useRouter } from 'next/router'

declare global {
  interface Window {
    googletag: any
  }
}
const AD_UNIT_PATH = process.env.NEXT_PUBLIC_INTERSTITIAL_TAG

let interstitialSlot: any | null = null
let gptInitialized = false

function initGPTInterstitial() {
  if (gptInitialized) return
  gptInitialized = true

  if (typeof window === 'undefined') return
  window.googletag = window.googletag || { cmd: [] }

  window.googletag.cmd.push(() => {
    interstitialSlot = window.googletag.defineOutOfPageSlot(
      AD_UNIT_PATH,
      window.googletag.enums?.OutOfPageFormat?.INTERSTITIAL
    )

    if (!interstitialSlot) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('[GPT] Interstitial não suportado nesta página/dispositivo.')
      }
      return
    }

    interstitialSlot
      .addService(window.googletag.pubads())
      .setConfig({
        interstitial: {
          triggers: {
            navBar: true,
            unhideWindow: true,
          },
        },
      })

    window.googletag.setConfig({ singleRequest: true })

    window.googletag.pubads().addEventListener('slotOnload', (evt: any) => {
      if (evt.slot === interstitialSlot) {
        if (process.env.NODE_ENV !== 'production') {
          console.log('[GPT] Interstitial carregado e pronto para disparar via trigger.')
        }
      }
    })

    window.googletag.enableServices()
    window.googletag.display(interstitialSlot)
  })
}

const InterstitialAd: React.FC = () => {
  const { asPath } = useRouter()
  const prevIsSection = useRef(false)
  const sessionData = useContext(SessionDataContext);

  useEffect(() => {
    if (typeof window === 'undefined') return
    window.googletag = window.googletag || { cmd: [] }
    if (sessionData?.nivelAcesso !== 'ASSINANTE') {
      initGPTInterstitial()
    }
  }, [])

  useEffect(() => {
    if (sessionData?.nivelAcesso !== 'ASSINANTE' && !prevIsSection.current && interstitialSlot) {
      window.googletag.cmd.push(() => {
      })
    }

  }, [asPath])

  return null
}

export default InterstitialAd
